/** @module csi/action/RefImageDropController */
define([
	"dojo/_base/declare",
	"csi/action/_ImageUploadMixin",
	"csi/heading/AttributeController"
], function(declare,_ImageUploadMixin,AttributeController) {
	
	/**
	 * This controller works for refImage heading in conjunction with _DndHTML5Mixin
	 * First add that mixin (_DndHTML5Mixin) to refImage declaration, then initialize is, and define onDrop function.
	 * Then _DndHTML5Mixin will accept dropped images and return list of dropped files to the widget
	 * Those files will be downloaded to the client and mixin returns {File[]) to the widget 
	 * 
	 * Then refImage invoking new AttributeAction(), using this controller, controller uploads images to the server - _ImageUploadMixin.preProcess();
	 * If successful it will call _ImageSaveMixin.onSave() to add images to the widget's root node.
	 * _toWriterValue will add selected image(s) to node
	 * PostProcess (AttributeController) - will then show those newly added images, selecting the first one.
	 * 
	 * Example: csi/property/Widget
	 */

	return declare([AttributeController,_ImageUploadMixin], {
		/**
		 * Add selected image(s) to node
		 * @param {string} id
		 * @param {string} type
		 */
		_toWriterValue: function(id, type) {
			return this._toWriterImages(id, type);
		}
	});
});